<script setup lang="ts">
import { mdToHtml } from '~/lib/markdown'
import { ProductMdwAllergens } from '~/lib/services/middleware/middleware.dtos'

const props = defineProps<{
  allergensArray: ProductMdwAllergens
}>()

const { t } = useLocale()
const productsConfig = useConfiguration('products')

const hasAllergens = computed(() => {
  if (!props.allergensArray) return false
  return !!Object.keys(props.allergensArray).length
})

const allergensDisclaimer = computed(() => {
  if (!productsConfig) return undefined
  const html = mdToHtml(productsConfig.allergensText)
  return html
})
</script>
<template>
  <section class="mt-6">
    <template v-if="hasAllergens">
      <div class="bg-[#EAEAEA] p-4 text-xs">
        <p class="font-bold">{{ t('productDetailStatic.allergens.tableTitle') }}</p>
      </div>

      <div class="grid grid-cols-[1fr_1fr]">
        <AllergenItem
          v-for="(_allergen, name, index) in allergensArray"
          :key="`allergen_${name}`"
          :allergen="name"
          :class="{ 'bg-white': index % 2 === 0, 'bg-mcd-secondaryIvory': index % 2 !== 0 }"
        />
      </div>
    </template>
    <template v-else>
      <p class="px-2 text-sm">{{ t('productDetailStatic.allergens.empty') }}</p>
    </template>

    <div
      v-if="allergensDisclaimer"
      v-dompurify-html="allergensDisclaimer"
      class="prose prose-sm mt-4 max-w-none px-2"
    ></div>
  </section>
</template>
